import React from 'react';
import * as PropTypes from 'prop-types';
import ChaMeta12 from 'dc/ChaMeta12';
import { Wrapper } from './elements';
import { getIndicator } from 'utils/common';
import { ICON } from 'resources/constants';
import { useFormatIndicator } from 'common/hooks';

import { TotalStats } from 'common/types';

type Props = {
  className?: string;
  sections: { [key: string]: { name: string } };
  sectionStats: { [key: string]: TotalStats };
  totalAverageIndicator: number;
  joinedSectionKey: string;
  readonly indicator: string;
  progressColor: string;
  indicatorIcon: string;
};

function ChStPrt2(props: Props): React.ReactElement {
  const {
    sections,
    sectionStats,
    totalAverageIndicator,
    joinedSectionKey,
    indicator,
  } = props;

  const formatIndicator = useFormatIndicator();

  const sortedSectionKeys = Object.keys(sections).sort(
    (currentSectionKey, nextSectionKey) => {
      const currentSection = sectionStats[currentSectionKey]
        ? getIndicator(sectionStats[currentSectionKey], indicator, 'average')
        : 0;
      const nextSection = sectionStats[nextSectionKey]
        ? getIndicator(sectionStats[nextSectionKey], indicator, 'average')
        : 0;

      return nextSection - currentSection;
    }
  );
  const highestSectionKey = sortedSectionKeys[0];
  const highestSectionIndicator = sectionStats[highestSectionKey]
    ? getIndicator(sectionStats[highestSectionKey], indicator, 'average')
    : 0;
  const highestSectionPercent =
    (highestSectionIndicator / totalAverageIndicator) * 100;

  return (
    <Wrapper className={props.className}>
      {sortedSectionKeys.map((sectionKey, index) => {
        const sectionIndicator = sectionStats[sectionKey]
          ? getIndicator(sectionStats[sectionKey], indicator, 'average')
          : 0;
        const percent = (sectionIndicator / totalAverageIndicator) * 100;
        const percentageFactor = highestSectionPercent / 100;

        return (
          <ChaMeta12
            type={'icon'}
            icon={ICON.locationCity}
            labelText={sections[sectionKey].name}
            userPosition={Boolean(sectionKey === joinedSectionKey)}
            position={index + 1}
            percent={percent / percentageFactor}
            progressColor={props.progressColor}
            value={formatIndicator(sectionIndicator, indicator)}
            valueIcon={props.indicatorIcon}
            key={sectionKey}
          />
        );
      })}
    </Wrapper>
  );
}

ChStPrt2.propTypes = {
  className: PropTypes.string,
  joinedSectionKey: PropTypes.string,
  indicatorIcon: PropTypes.string,
  progressColor: PropTypes.string,
  sections: PropTypes.object,
  sectionStats: PropTypes.object,
  totalAverageIndicator: PropTypes.number,
};

export default ChStPrt2;
